<!--
    file type .....: HTML file: existing-members.component.html
    Created By ....: ianday
    Date ..........: 3/7/24 
-->
<div class="existing-members-container">
        <div style="padding-bottom: 13px;color: blue;">One or more members were found with this name and date of
            birth.<br />
        Select the record and click submit to choose or click cancel if this is a different person.
        </div>
        <div #tb1 class="table-container mat-elevation-z1"

             (keydown)="tableKeyDown($event)" tabindex="-1">

            <table mat-table [dataSource]="dataSource" style="width:100%" >
                <!-- ID -->
                <ng-container matColumnDef="id" >
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style table-header-class"
                        style="width:100px; padding-left: 2px"> Id</th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        style="width:100px; padding-left: 2px;">
                        {{element.id}} </td>
                </ng-container>
                <!-- memberName -->
                <ng-container matColumnDef="memberName" >
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style table-header-class" style="width:50%"> Member Name</th>
                    <td mat-cell *matCellDef="let element" class="table-row-class"
                        style="width:50%">
                        {{returnFullName(element)}} </td>
                </ng-container>

                <!-- gender -->
                <ng-container matColumnDef="gender" >
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style table-header-class"style="width:15%"> Gender</th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" style="width:15%">
                        {{element.gender}} </td>
                </ng-container>

                <!-- dob -->
                <ng-container matColumnDef="dateOfBirth" >
                    <th mat-header-cell *matHeaderCellDef
                        class="mat-table-header-style table-header-class" style="width:20%;"> Date of Birth</th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" style="width:20%;">
                        {{truncateDOB(element.dateOfBirth)}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': tableRowIdx == Idx}"
                    (click)="onRowClicked(row)"  (dblclick)="onRowDoubleClicked(row)">
                </tr>


            </table>
        </div>


</div>
<!----------------------->
<!-- ERROR LINE --------->
<!----------------------->
<div class="error-line" [hidden]='!strErr.length'
     style="text-align:left;bottom: 65px;">{{strErr}}</div>
<!----------------------->
<!-- SAVE STRIP        -->
<!----------------------->
<div class="save-close-strip" style="bottom: 13px;">

    <button mat-button class="command-button" [disabled]="!submitEnabled"
            (click)="submitRecord()" matTooltip="Save the record"
            mat-button>
        <mat-icon>check_circle_outline</mat-icon>
        Submit
    </button>
    <button mat-button class="command-button"
            (click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
        <mat-icon>highlight_off</mat-icon>
        Cancel
    </button>
</div>
